/* eComHQ scroll pass (owner, October 20, 2026: "on the prdict page, someitmes you can't scroll down page because for some
   reason the page is stuck. srcolling the image gallery. fix this globally"). shopify/scroll-pass/README.md

   1. A sideways carousel (gallery track, review row, slider) never scrolls up and down. Setting overflow-x makes the
      browser treat overflow-y as auto too, so a few pixels of image or rounding below a slide gave the track a vertical
      scroll range. A wheel or trackpad gesture that starts over it then latches to the track, moves it those pixels and the
      page does not move for the rest of the gesture. Every sideways scroller with no real vertical content gets
      overflow-y:hidden; horizontal swiping and scroll-snap are unchanged.
   2. A small vertical scroller in the page (the thumbnail rail) scrolls while it can, and the rest of the same gesture
      goes to the page. The browser keeps a gesture on the element it started on, so once the rail reaches its end the page
      would sit still until the next gesture. The page is moved by the remaining delta only when the browser did not chain
      it itself. No wheel event is cancelled, and nothing inside a fixed layer (cart drawer, dialog, menu) is touched.
*/
(function () {
  if (window.EHQScrollPass) return;
  var scrolls = /(auto|scroll)/;

  function sideways(el, cs) {
    if (!scrolls.test(cs.overflowX) || cs.overflowY === 'hidden' || cs.overflowY === 'clip') return false;
    var snapX = /x|inline|both/.test(cs.scrollSnapType || ''), wide = el.scrollWidth > el.clientWidth + 1;
    if (!snapX && !wide) return false;
    // Real vertical content (a scroller meant to go both ways) keeps its own overflow.
    return el.scrollHeight - el.clientHeight < Math.max(24, el.clientHeight * 0.25);
  }

  function fix() {
    var all = document.body ? document.body.getElementsByTagName('*') : [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.clientWidth < 40 || el.clientHeight < 40) continue;
      var cs = getComputedStyle(el);
      if (sideways(el, cs)) { el.style.overflowY = 'hidden'; el.setAttribute('data-ehq-scroll-pass', 'x'); }
    }
  }

  var queued = 0;
  function later() { if (queued) return; queued = setTimeout(function () { queued = 0; fix(); }, 150); }

  function inFixedLayer(el) {
    for (var e = el; e && e !== document.body; e = e.parentElement) {
      var p = getComputedStyle(e).position;
      if (p === 'fixed' || e.tagName === 'DIALOG' || e.getAttribute('aria-modal') === 'true') return true;
    }
    return false;
  }

  function scroller(target) {
    for (var e = target; e && e !== document.body && e !== document.documentElement; e = e.parentElement) {
      if (e.nodeType !== 1) continue;
      var cs = getComputedStyle(e);
      if (scrolls.test(cs.overflowY) && e.scrollHeight > e.clientHeight + 1) return e;
    }
    return null;
  }

  function canMove(el, dy) {
    return dy > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 1 : el.scrollTop > 0;
  }

  // One gesture: wheel events less than 200 ms apart in the same direction.
  var gesture = null;
  function wheel(ev) {
    if (ev.ctrlKey || Math.abs(ev.deltaY) <= Math.abs(ev.deltaX)) { gesture = null; return; }
    var dy = ev.deltaY * (ev.deltaMode === 1 ? 16 : ev.deltaMode === 2 ? innerHeight : 1);
    var now = ev.timeStamp || Date.now(), dir = dy > 0 ? 1 : -1;
    if (!gesture || now - gesture.t > 200 || gesture.dir !== dir) {
      var el = scroller(ev.target);
      // Started where the page scrolls natively, or on a scroller that cannot move: the browser chains it already.
      gesture = el && !inFixedLayer(el) && canMove(el, dy) ? { el: el, dir: dir, y: scrollY } : { el: null, dir: dir };
    }
    gesture.t = now;
    if (!gesture.el || canMove(gesture.el, dy)) { gesture.y = scrollY; return; }
    // The rail is at its end and the page has not moved by itself since the last event: pass the delta on.
    if (scrollY === gesture.y) window.scrollBy(0, dy);
    gesture.y = scrollY;
  }

  function start() {
    fix();
    addEventListener('load', fix);
    addEventListener('resize', later, { passive: true });
    if ('MutationObserver' in window) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('wheel', wheel, { passive: true, capture: true });
  }

  window.EHQScrollPass = { fix: fix };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
